import {useContext, useEffect, useId, useRef, useState} from "react";
import FontAwesomeButton from "../cards/FontAwesomeButton";
import {ApiContext} from "../../util/Requests";


const ModalButton = ({icon, buttonType, toolTip, children, extraStyle, cursor}) => {
    const myid = useId();
    
    const [isOpen, setIsOpen] = useState(false);

    const {modals} = useContext(ApiContext);

    const usedChild = useRef(null);

    useEffect(() => {
        if (children)
            children.props.onClose = () => {
                setIsOpen(false);
            }

        usedChild.current = children;
    }, [children]);

    useEffect(() => {
        if (isOpen)
            modals.add(myid, usedChild);
        else
            modals.remove(myid);
    }, [isOpen]);
    
    useEffect(() => {
        return () => {
            modals.remove(myid);
        }
    }, []);

    if (icon)
        return <FontAwesomeButton extraStyle={{...extraStyle, cursor}} buttonType={buttonType} icon={icon} enabled={buttonType?.enabled} title={toolTip} onClick={(e) => {
            setIsOpen(true);
            e.stopPropagation();
            e.preventDefault();
        }} />
    else
        return <button style={extraStyle} type={"button"} onClick={(e) => {
            setIsOpen(true);
            e.stopPropagation();
            e.preventDefault();
        }}>{toolTip}</button>
}

export default ModalButton;